import { apiCall, createQueryString } from "../imports"

const PREFIX = "shop/designers"

export default {

    get(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`)
    },

    orders(id, filters) {
        return apiCall('get', `${PREFIX}/${id}/orders${createQueryString(filters)}`)
    },

    deposits(id, filters) {
        return apiCall('get', `${PREFIX}/${id}/deposits${createQueryString(filters)}`)
    },

    myOrders(filters) {
        return apiCall('get', `${PREFIX}/my-orders${createQueryString(filters)}`)
    },

    myDeposits(filters) {
        return apiCall('get', `${PREFIX}/my-deposits${createQueryString(filters)}`)
    }
}